import { render } from "./PageLoading.vue?vue&type=template&id=ba8c4aa6"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/loaders/PageLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba8c4aa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba8c4aa6', __exports__)) {
    api.reload('ba8c4aa6', __exports__)
  }
  
  module.hot.accept("./PageLoading.vue?vue&type=template&id=ba8c4aa6", () => {
    api.rerender('ba8c4aa6', render)
  })

}


export default __exports__